import { PROFILE_CONTENT_SX } from "../components/profileFieldStyles";
import React from "react";
import { useParams } from "react-router-dom";
import CandidateProfileTabs from "../components/CandidateProfileTabs";
import CandidateProfilePanels from "../components/CandidateProfilePanels";
import { TabsProvider } from "../components/TabsContext";

import {
  Box,
  Divider,
  Paper,
} from "@mui/material";
import useAuthController from "../hooks/useAuthController";

// Layout wrappers
import MainContent from "../components/MainContent";
import TwoColumnLayout from "../layouts/TwoColumnLayout";

// Sidebar widgets
import { HRManagerAgenda } from "../components/HRManagerAgenda";
import CandidateBySource from "../components/CandidateBySource";

import { candidates } from "../assets/candidates";

export default function CandidateProfile() {
  const { user, loading, handleLogout } = useAuthController();
  const { id } = useParams();
  const candidateId = parseInt(id, 10);

  
  const candidate =
    candidateId >= 0 && candidateId < candidates.length ? candidates[candidateId] : null;

  if (loading) return <p>Loading...</p>;
  if (!candidate) return <p>Candidate not found</p>;

  return (
    <MainContent user={user} onLogout={handleLogout}>
      <TwoColumnLayout>
        {/* ================= LEFT COLUMN ================= */}
        <div className="left-column" style={{ width: "100%" }}>
          <Paper
            elevation={0}
            className="boxCard"
            sx={{
              p: 0,

            }}
          >
            {/* ---------- Header ---------- */}
          <TabsProvider>
            <Box sx={{ ...PROFILE_CONTENT_SX, bgcolor: "#fff", p: 4 }}>
              <CandidateProfileTabs />
              <Divider sx={{ mt: 1 }} />
              <CandidateProfilePanels />
            </Box>
          </TabsProvider>
            
          </Paper>
        </div>

        {/* ================= RIGHT COLUMN ================= */}
        <div className="right-column">
          <div className="boxCard">
            <HRManagerAgenda />
          </div>
          <div className="section-row">
            <div className="boxCard">
              <CandidateBySource />
            </div>
          </div>
        </div>
      </TwoColumnLayout>
    </MainContent>
  );
}
